import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideExternalLink, lucideLockKeyhole } from '@ng-icons/lucide';
import { TranslateModule } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { environment } from '../../../environments/environment';
import { Footer } from '../../app-core/ui/footer/footer';
import { Logo } from '../../app-core/ui/logo/logo';

/**
 * Shown on the login callback to users who signed in to Okta but are not allowed to use IMDB
 * (Figma "Access Denied", node 871:987). Both destinations come from the environment
 * configuration, so DEV, STG and PRD never point at each other's URLs. Everything uses theme
 * tokens, so the page follows the light/dark theme; only the corner artwork keeps its brand colours.
 */
@Component({
    selector: 'app-access-denied',
    imports: [TranslateModule, NgIcon, HlmButtonImports, Logo, Footer],
    providers: [provideIcons({ lucideExternalLink, lucideLockKeyhole })],
    templateUrl: './access-denied.html',
    host: { class: 'block' },
})
export class AccessDenied {
    protected readonly requestAccessUrl = environment.accessDenied.requestAccessUrl;
    protected readonly oktaUrl = environment.accessDenied.oktaUrl;
}
